import _ from 'lodash';
import buildBuilders from '@/api/amplify/lib/factories/buildBuilders';
import blueRoundel from '@/assets/img/roundel-icon-blue.svg';

const coloursType = {
  primary: { default: '#3771d0' },
  success: { default: '#53C475' },
  warning: { default: '#ECB233' },
  error: { default: '#E64C4C' },
  chart: {
    default: [
      '#0077b8',
      '#ff7100',
      '#00a719',
      '#fc001b',
      '#a55dc1',
      '#9e5149',
      '#ff65c4',
      '#7f7f7f',
      '#bbc000',
      '#00c3d1',
      '#000000',
    ],
  },
};

const defaultColours = _.cloneDeep(coloursType);

const type = {
  version: { default: 0 },
  emblem: { default: blueRoundel },
  logo: { default: null },
  title: { default: 'DevicePilot' },
  favicon: { default: '/favicon-32x32.png' },
  brandColour: { default: '#3771d0' },
  colours: coloursType,
};

const { build } = buildBuilders('settings', type);
export { build, defaultColours };
